import { ArrowBackIos } from '@mui/icons-material'
import React from 'react'
import { getStatusNameByValue } from '../../../uitls/Utils'

export default function NavigationSection({title, onBack}) {
  return (
  
        <div className="mb-4 md:mb-6 w-full">
                  <div className="flex items-center justify-between">
                    <button
                      onClick={onBack}
                      className="flex items-center gap-2 px-4 py-2.5 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200 group font-medium"
                    >
                      <ArrowBackIos className="w-4 h-4 md:w-5 md:h-5 group-hover:-translate-x-1 transition-transform duration-200" />
                      <span className="text-sm md:text-base">
                        Go Back
                      </span>
                    </button>
                    {title && (
                      <div className="flex items-center gap-3 bg-gradient-to-r from-[#0b3a5c] to-[#135e96] px-5 py-2.5 rounded-lg shadow-md border border-white/20">
                        <span className="text-xs font-semibold text-white/90 uppercase tracking-wide">
                          Status:
                        </span>
                        <div className="text-white font-bold text-sm md:text-base">
                          {getStatusNameByValue(title)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
 
  )
}
